import axios from "axios";
import React, { useState, useEffect } from "react";
import "./HomePage.css";
import { toast } from "react-toastify";
import base_url from "../../Utils/server";

const connections = ["E", "we", "e"];
export const HomePageConnections = ({
  nonConnections,
  setNonConnections,
  Token,
}) => {
  const [matchArray1, setMatchArray1] = useState(nonConnections);
  const [noMatch1, setNoMatch1] = useState(null);
  useEffect(() => {
    axios
      .get(`${base_url}/nonconnections`, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      })
      .then((res) => {
        setNonConnections(res.data.data);
        setMatchArray1(res.data.data);
      })
      .catch((e)=>{
        toast.error("Error fecthing non connections")
      });
    }, []);
 
  function handleconnections(e, name) {
    let data = {};
    axios
      .post(`${base_url}/follow/user/${name}`, data, {
        headers: {
          Authorization: `Bearer ${Token}`,
        },
      })
      .then((res) => {
        e.target.innerText = "Connected";
        e.target.style.backgroundColor = "black";
        e.target.style.color = "white";
        toast.success("Connection Added Successfully", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1200,
        });
        setTimeout(() => {
          axios
          .get(`${base_url}/nonconnections`, {
            headers: {
              Authorization: `Bearer ${Token}`,
            },
          })
          .then((res) => {
            setNonConnections(res.data.data);
            setMatchArray1(res.data.data);
            e.target.style.backgroundColor = "white";
              e.target.style.color = "black";
              e.target.innerText = "Connect";
            })
            .catch((e)=>{
              toast.error("Error fecthing non connections")
            });
        }, 2000);
      })
      .catch((e)=>{
        toast.error("Error fecthing non connections")
      });
  }
  function findMatches1(wordToMatch, nonConnections) {
    return nonConnections.filter((nonConnection) => {
      // here we need to figure out if the city or state matches what was searched
      const regex = new RegExp(wordToMatch, "gi");
      return nonConnection.userName.match(regex) || nonConnection.userFullName.match(regex);
    });
  }
  function handleSearch1(e) {
    // console.log(e);
    const matchArray1 = findMatches1(e.target.value, nonConnections);
    // console.log(matchArray1);
    if (e.target.value.length > 0) {
      if (matchArray1.length == 0) {
        setNoMatch1("no");
      } else {
        setMatchArray1(matchArray1);
        setNoMatch1(null);
      }
    } else {
      setNoMatch1(null);
      setMatchArray1(nonConnections);
    }
  }
  let non5 = matchArray1.filter((val, id) => {
    return id < 6;
  });
  return (
    <section className="relative">
      <section className="absolute right-6 pt-8 w-1/5 min-h-screen .overflow-x-hidden">
        <span className="block pb-6 text-black-200 text-2xl  font-semibold mb-4">
          New Connections
        </span>
        <div className="relative mb-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="absolute top-0 bottom-0 w-6 h-6 my-auto text-gray-400 left-3"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              />
            </svg>
            <input
              onChange={(e) => {
                handleSearch1(e);
              }}
              type="text"
              placeholder="Search Connections"
              className="w-full py-3 pl-12 pr-4 text-gray-500 border rounded-md outline-none bg-gray-50 focus:bg-white focus:border-indigo-600"
            />
          </div>
          {noMatch1 && (
                <span className="block text-gray-700 text-sm font-semibold">
                  No match found
                </span>
              )}
          {matchArray1.length == 0 && (
                <span className="block text-gray-700 text-sm font-semibold">
                  No more Users left for Connections.
                </span>
              )}
              {noMatch1 == null &&
                matchArray1.length > 0 && (
          <ul className="grid gap-2 sm:grid-cols-1 md:grid-cols-1">
            {non5.map((item, id) => {
              return (
                <li key={id}>
                  <div className="py-4 px-4 border-2 rounded-xl opac-controller">
                    <div className="flex items-center justify-between gap-x-4">
                      <div className="flex gap-x-2 items-center">
                        <img
                          src={item.profileImage}
                          className="w-10 h-10 rounded-full"
                        />
                        <div>
                          <span className="block text-gray-700 text-base font-semibold">
                            {item.userFullName}
                          </span>
                        </div>
                      </div>
                      <button
                        className="block mt-px text-black border-2 border-black rounded-md px-4 py-2 text-sm"
                        onClick={(e) => {
                          handleconnections(e, item.userName);
                        }}
                      >
                        Connect
                      </button>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        )}
        {/* {nonConnections.length == 0 && (
          <span className="block text-gray-700 text-base font-semibold">
            No Users left for connections
          </span>
        )} */}
      </section>
    </section>
  );
};
